import React from "react";

interface IStyleProps {
  fillColor?: string;
}

const EditButtonIcon: React.FC<IStyleProps> = (props) => {
  return (
    <svg width="21" height="15" viewBox="0 0 21 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="21" height="15" rx="2" fill="#000"/>
    </svg>
  );
}

export default EditButtonIcon;